/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { SiteSearch } from '../../interfaces/site-search.interface';

export enum ActionTypes {
    SiteSearchQuery         = '[Site Search] - Query',
    SiteSearchNavigate      = '[Site Search] - Navigate'
}

export class SiteSearchQuery implements Action {
    readonly type = ActionTypes.SiteSearchQuery;
    constructor(public payload: SiteSearch) {}
}

export class SiteSearchNavigate implements Action {
    readonly type = ActionTypes.SiteSearchNavigate;
    constructor(public payload: {category: string; search: SiteSearch}) {}
}

export type SiteActions = SiteSearchQuery | SiteSearchNavigate;
